import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const submitContact = (data) =>
  api.post("/contact", data).then((r) => r.data);

export const submitQuestionnaire = (data) =>
  api.post("/questionnaire", data).then((r) => r.data);

export const submitCallRequest = (data) =>
  api.post("/call-requests", data).then((r) => r.data);

export const submitTestimonial = (data) =>
  api.post("/testimonials", data).then((r) => r.data);

export const approveTestimonial = (id, status) =>
  api.post(`/admin/testimonials/${id}/status`, { status }).then((r) => r.data);

export const adminLogin = (access_code) =>
  api.post("/admin/login", { access_code }).then((r) => r.data);

export const adminLogout = () =>
  api.post("/admin/logout").then((r) => r.data);

export const getSubmissions = () =>
  api.get("/admin/submissions").then((r) => r.data);
